<pathPantalla></pathPantalla>

<div class="row" [hidden]="consulta">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3>{{sistemaService.NombrePantallaActual}}</h3>
                <div>
                    <button class="btn boton botonXS" (click)="Modal()" *ngIf="sistemaService.permisos.edicionespecial">
                      <span> {{'Parametros'}}</span>
                    </button>
                </div>
            </header>
            <div class="separador"></div>

            <div class="row margen sticky" style="z-index: 1000">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12" style="box-shadow: 0 1px 0px 0 rgb(0 0 0 / 20%); background-color: #fff;">
                    <div class="col-12" style="padding-top: 8px;">
                        <div class="row margen">
                            <div class="col-lg-6 col-md-12" style="padding-left: 0px;">
                                <div class="panelCamposHorizontal">
                                    <button class="boton botonSM filled cell" (click)="ExpCont()">
                                        {{expandir ? 'Contraer todos' : 'Expandir todos'}}
                                    </button>
                                    <div class="divisorH16 cell"></div>
                                    <!-- <button class="boton botonSM filled cell" (click)="ExpCont2()" *ngIf="verboton">
                                        Ubicar
                                    </button> -->
                                    <div class="divisorH16 cell"></div>
                                    <button class="boton botonSM filled cell" (click)="AgregarDepartamento()">
                                        Agregar departamento raíz
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12" style="padding-left: 0px;">
                                <div class="panelCamposHorizontal">
                                    <checkBoxCustom
                                    class="cell"
                                    [sinMargen]="true"
                                    [titulo]="'Ver puestos'"
                                    [alineacion]="1"
                                    [(ngModel)]="filtros.puesto"
                                    (ngModelChange)="filtros.colaborador = !filtros.puesto ? false : filtros.colaborador; Buscar()"
                                    ></checkBoxCustom>
                                <div class="divisorH16 cell"></div>
                                <checkBoxCustom
                                    class="cell"
                                    [sinMargen]="true"
                                    [titulo]="'Ver colaboradores'"
                                    [alineacion]="1"
                                    [(ngModel)]="filtros.colaborador"
                                    (ngModelChange)="filtros.puesto = filtros.colaborador ? true : filtros.puesto; Buscar()"
                                    ></checkBoxCustom>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12 hidden-sm-down">
                    <div class="col-12 sticky" style="padding-top: 8px;">
                        <ng-container *ngTemplateOutlet="botnesAccion;"></ng-container>
                    </div>
                </div>
            </div>
            <div class="divisor8"></div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12 card">
                    <div class="col-12" *ngIf="organigrama">
                        <div class="divisor16" *ngIf="organigrama.length == 0"></div>
                        <button
                            class="boton filled-line-ending"
                            *ngIf="organigrama.length == 0"
                            (click)="AgregarDepartamento()"
                            >
                            Empezar
                        </button>
                        <div class="divisor16"></div>
                        <dx-sortable
                            filter=".dx-treeview-item"
                            [allowDropInsideItem]="true"
                            [allowReordering]="false"
                            (onDragChange)="onDragChange($event)"
                            (onDragEnd)="onDragEnd($event)"
                            >
                            <dx-tree-view
                                id="treeview"
                                [dataSource]="organigrama"
                                dataStructure="tree"
                                (onItemClick)="selectItem($event)"
                                [searchEnabled]="true"
                                searchMode="contains"
                                (onItemContextMenu)="treeViewItemContextMenu($event)"
                                itemTemplate="itemTemplate"
                                >
                                <dxo-search-editor-options placeholder="Buscar"> </dxo-search-editor-options>
                                <div *dxTemplate="let itemObj of 'itemTemplate'">
                                    <div class="IconoRenglon">
                                        <div *ngIf="itemObj.tipo == 1">
                                            <svg-icon
                                                class="iconoSVG"
                                                src="./assets/Icono/direccion.svg"
                                                >
                                            </svg-icon>
                                        </div>
                                        <div *ngIf="itemObj.tipo == 2">
                                            <svg-icon
                                                class="iconoSVG"
                                                src="./assets/Icono/puesto.svg"
                                                ></svg-icon>
                                        </div>
                                        <div *ngIf="itemObj.tipo == 3">
                                            <svg-icon
                                                class="iconoSVG"
                                                src="./assets/Icono/colaborador.svg"
                                                >
                                            </svg-icon>
                                        </div>
                                        <div [ngClass]="itemObj.obj.activo == false ? 'textoRojo' : 'texto'">{{itemObj.text}}</div>
                                    </div>
                                </div>
                            </dx-tree-view>
                        </dx-sortable>
                        <dx-context-menu
                            [dataSource]="menuItems"
                            target="#treeview .dx-treeview-item"
                            (onItemClick)="contextMenuItemClick($event)"
                            >
                        </dx-context-menu>
                        <div class="divisor16"></div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-12 hidden-md-up">
                    <div class="col-12 sticky">
                        <ng-container *ngTemplateOutlet="botnesAccion;"></ng-container>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-12 card" style="padding-left: 0px;">
                    <div *ngIf="tipo" class="sticky" style="top:100px;">
                        <div [ngClass]="{'soloLectura' : !editable}">
                            <div class="col-12" *ngIf="tipo == 1">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 form-group">
                                        <h4> Departamento</h4>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="!editable"
                                            [titulo]="'Descripción'"
                                            [(ngModel)]="entidad.nombre"
                                            [errorActivo]="errorActivo"
                                            ></inputCustom>
                                    </div>
                                    <!--<div class="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <dropdownCustom [disabled]="!editable"
                                            [titulo]="'Tipo de departamento'"
                                            (ngModelChange)="AsociarNivel($event)"
                                            [(ngModel)]="entidad.tipodepartamentoid"
                                            [opciones]="SelTipoDepartamento"
                                            [valorName]="'tipodepartamentoid'"
                                            [displayValor]="'nombre'"
                                            [errorActivo]="errorActivo"
                                            ></dropdownCustom>
                                    </div>-->
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-12">
                                        <dropdownCustom [disabled]="!agregarD"
                                            [titulo]="'Departamento superior'"
                                            [(ngModel)]="entidad.departamentosuperiorid"
                                            [opciones]="SelDepartamento"
                                            [valorName]="'departamentoid'"
                                            [displayValor]="'nombre'"
                                            ></dropdownCustom>
                                    </div>
                                </div>
                                <div class="row margen">
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                        <checkBoxCustom [disabled]="!editable  || nivelobligatorio"
                                            [titulo]="'Forma parte de un nivel'"
                                            [alineacion]="1"
                                            [(ngModel)]="entidad.nivel"
                                            ></checkBoxCustom>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-6 col-12">
                                        <dropdownCustom [disabled]="!editable"
                                            *ngIf="entidad.nivel"
                                            [titulo]="'Nivel del que forma parte el departamento'"
                                            [(ngModel)]="entidad.nivelid"
                                            [opciones]="SelNivel"
                                            [valorName]="'nivelid'"
                                            [displayValor]="'nombre'"
                                            [errorActivo]="errorActivo"
                                            ></dropdownCustom>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                        <checkBoxCustom [disabled]="!editable"
                                            [titulo]="'Es área académica'"
                                            [alineacion]="1"
                                            [(ngModel)]="entidad.areaacademica"
                                            ></checkBoxCustom>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-6 col-12">
                                        <dropdownCustom [disabled]="!editable"
                                            *ngIf="entidad.areaacademica"
                                            [titulo]="'Área académica signada'"
                                            [(ngModel)]="entidad.areaacademicaid"
                                            [opciones]="SelAreaAcademica"
                                            [valorName]="'areaacademicaid'"
                                            [displayValor]="'nombre'"
                                            [buscar]="true"
                                            [errorActivo]="errorActivo"
                                            ></dropdownCustom>
                                    </div>
                                </div>
                                <div class="row margen">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <checkBoxCustom [disabled]="!editable"
                                            [titulo]="'Activo'"
                                            [alineacion]="1"
                                            [(ngModel)]="entidad.activo"
                                            ></checkBoxCustom>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="tipo == 2">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 form-group">
                                        <h4> Puesto</h4>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                                        <inputCustom [disabled]="!editable"
                                            [titulo]="'Descripción'"
                                            [(ngModel)]="entidad.nombre"
                                            [errorActivo]="errorActivo"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-12">
                                        <dropdownCustom [disabled]="!agregarP"
                                            [titulo]="'Departamento'"
                                            [(ngModel)]="entidad.departamentoid"
                                            (ngModelChange)="RemoverIdPuesto(entidad.puestoid, $event)"
                                            [opciones]="SelDepartamentoFull"
                                            [valorName]="'departamentoid'"
                                            [displayValor]="'nombre'"
                                            [errorActivo]="errorActivo"
                                            ></dropdownCustom>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-12">
                                        <dropdownCustom [disabled]="!editable"
                                            [titulo]="'Puesto superior'"
                                            [(ngModel)]="entidad.puestosuperiorid"
                                            [opciones]="SelPuesto"
                                            [valorName]="'puestoid'"
                                            [displayValor]="'nombre'"
                                            ></dropdownCustom>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-12" *ngIf="mostrarMaterias">
                                      <dropdownCustom [disabled]="!editable"
                                          [titulo]="'Materias'"
                                          [(ngModel)]="entidad.materiasid"
                                          [opciones]="SelMaterias"
                                          [valorName]="'materiaid'"
                                          [displayValor]="'materia'"
                                          [multiSelect]="true"
                                          [buscar]="true"
                                          ></dropdownCustom>
                                  </div>
                                </div>
                                <div class="row margen">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <checkBoxCustom [disabled]="!editable"
                                            [titulo]="'Docente'"
                                            [alineacion]="1"
                                            [(ngModel)]="entidad.esdocente"
                                            ></checkBoxCustom>
                                    </div>
                                </div>
                                <div class="row margen">
                                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                                      <checkBoxCustom [disabled]="!editable"
                                          [titulo]="'Ver otros puestos'"
                                          [alineacion]="1"
                                          [(ngModel)]="entidad.otropuesto"
                                          (ngModelChange)="BuscarGrado($event)"
                                          ></checkBoxCustom>
                                  </div>
                                  <div class="col-lg-8 col-md-6 col-sm-6 col-12" *ngIf="entidad.otropuesto">
                                    <dropdownCustom [disabled]="!editable"
                                        [titulo]="'Grados asignados'"
                                        [(ngModel)]="entidad.gradosid"
                                        [opciones]="SelGrado"
                                        [valorName]="'gradoid'"
                                        [displayValor]="'nombre'"
                                        [multiSelect]="true"
                                        [buscar]="true"
                                        [errorActivo]="errorActivo"
                                        ></dropdownCustom>
                                </div>
                              </div>
                                <div class="row margen">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <checkBoxCustom [disabled]="!editable"
                                            [titulo]="'Activo'"
                                            [alineacion]="1"
                                            [(ngModel)]="entidad.activo"
                                            ></checkBoxCustom>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" *ngIf="tipo == 3">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 form-group">
                                        <h4> Colaborador</h4>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Nº nómina'"
                                            [(ngModel)]="entidad.nomina"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Nombre'"
                                            [(ngModel)]="entidad.nombre"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Ap. paterno'"
                                            [(ngModel)]="entidad.apellidopaterno"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Ap. materno'"
                                            [(ngModel)]="entidad.apellidomaterno"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Tipo de colaborador'"
                                            [(ngModel)]="entidad.tipocolaborador"
                                            ></inputCustom>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <inputCustom [disabled]="true"
                                            [titulo]="'Estatus del colaborador'"
                                            [(ngModel)]="entidad.estatuscolaborador"
                                            ></inputCustom>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="col-12">
                                <div class="row" *ngIf="tipo == 1 || tipo == 2">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div class="panelBotonesFiltro mixto">
                                            <button
                                                *ngIf="!editable"
                                                class="boton botonSM filled"
                                                (click)="editable = true"
                                                >
                                                Editar
                                        </button>
                                        <div class="derecha" *ngIf="editable">
                                            <button class="boton botonSM filledBlanco" (click)="Cancelar()">
                                                Cancelar
                                            </button>
                                            <div class="divisorH16"></div>
                                            <button class="boton botonSM filled" (click)="Guardar()">
                                                Guardar
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row" *ngIf="tipo == 3">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div class="panelBotonesFiltro">
                                        <button class="boton botonSM filled" (click)="VerColaborador(entidad.colaboradorid)">
                                            Ver detalle
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</div>

<ng-template #botnesAccion>
    <div class="panelCamposHorizontal">
        <div class="divisorH16 cell"></div>
        <button class="boton botonSM filled cell" (click)="AsignacionColaboradores()">
            Exportar asignación de colaboradores
        </button>
        <div class="divisorH16 cell"></div>
        <button class="boton botonSM filled cell" (click)="ValidarAsignacion()">
            Validar asignación de colaboradores
        </button>
    </div>
</ng-template>

<colaboradormodal
    #colaborador
    (respuesta)="GuardarColaborador($event)"
    ></colaboradormodal>

<div #containerFormulario></div>

<ng-container *ngIf="abierto">
  <div class="backdrop"></div>
  <div class="modalPanelAdmin small animated {{animacion}}">

      <div class="contenido">
          <!-- Título -->
          <div class="encabezadoModal">
              <div class="modalTituloSimple">
                  Editar parametros (Perfiles ID)
              </div>
          </div>
          <div class="modalContenido">
              <!-- datos -->
              <div>
                  <div class="divisor8"></div>
                  <div>
                      <!-- Datos generales -->
                      <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                              <inputCustom [titulo]="'Perfil ID de jefe de área'" [(ngModel)]="parametroJefe.valor" [errorActivo]="errorActivo"></inputCustom>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                          <inputCustom [titulo]="'Perfil ID de jefe de colaborador'" [(ngModel)]="parametroColaborador.valor" [errorActivo]="errorActivo"></inputCustom>
                      </div>
                      </div>
                  </div>
              </div>

          </div>

          <!-- footer -->
          <div class="modalFooter">
              <div class="contenidoFooter botonesIzq">
                  <!-- editar -->
                  <div class="botonDerecha">
                      <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                          {{'Cancelar' | translate}}
                      </button>
                      <div class="divisorH16"></div>
                      <button class="boton botonSM filled" (click)="GuardarParametros()">
                          {{'Guardar' | translate}}
                      </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</ng-container>
